const getItem = (key: string): string | null | undefined => {
	try {
		return window.localStorage.getItem(key);
	} catch (error) {
		console.warn(`[ERROR] Failed to call localStorage.getItem`, error);
	}
};

const setItem = (key: string, value: string): void => {
	try {
		window.localStorage.setItem(key, value);
	} catch (error) {
		console.warn(`[ERROR] Failed to call localStorage.setItem`, error);
	}
};

const removeItem = (key: string): void => {
	try {
		window.localStorage.removeItem(key);
	} catch (error) {
		console.warn(`[ERROR] Failed to call localStorage.removeItem`, error);
	}
};

const localStorage = {
	getItem,
	setItem,
	removeItem,
};

export default localStorage;
